import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './ProfileIconLoader.module.scss';

const ProfileIconLoader = () => (
  <div className={styles.container}>
    <Skeleton circle width={40} height={40} />
    <Skeleton width={70} height={16} />
  </div>
);

export default ProfileIconLoader;
